var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideShowGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2206,
    height: 1183,
    viewBox: "0 0 2206 1183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_155_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1956 628C1956 717.376 1851.13 811.413 1736.4 872.158C1609.74 939.221 1314.31 931.119 1113.34 931.119C928.962 931.119 592.512 946.564 468.292 888.948C334.46 826.874 250.5 741.525 250.5 644C250.5 532.737 328.667 369.284 496.772 307.152C612.782 264.274 956.943 250.144 1113.34 250.144C1307.02 250.144 1610.57 244.296 1736.4 307.152C1859.39 368.594 1956 535.047 1956 628Z",
    fill: "url(#paint0_linear_155_67)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_155_67",
    x: 0.5,
    y: 0,
    width: 2205.5,
    height: 1183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_155_67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_67",
    x1: 296.5,
    y1: 482.5,
    x2: 1874.69,
    y2: 1048.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4371F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8A917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#FBB90F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8FF05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideShowGlow);
export default __webpack_public_path__ + "static/media/slideShowGlow.52d21c4948edcf6c37b36a5a6bf63fc0.svg";
export { ForwardRef as ReactComponent };